import { render, staticRenderFns } from "./TableTh.vue?vue&type=template&id=64678b11"
import script from "./TableTh.vue?vue&type=script&lang=js"
export * from "./TableTh.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports